import { useEffect } from "react";

/**
 * Lightweight SEO hook — updates <title> and <meta name="description"> on route change.
 * No react-helmet dependency; enough for a client-side SPA to be per-route friendly to crawlers.
 */
export function useSEO({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);
}
